import { Deserializable } from '../_common/deserializable';

export class Advertiser implements Deserializable {
  id: number;
  advertiser: string;
  offerId: string;
  description: string;
  slice: string;
  timezone: string;
  min: number;
  rate: number;
  max: number;
  url: string;
  customizedUrl: string;
  updatedAt: number;
  createdAt: number;

  deserialize(input: any): this {
    return Object.assign(this, input);
  }
}
